import { UserAuthenticated } from '@/redux/user/types'

export const SUPPORT_SUPERUSER_EMAIL = 'superusersup@devzapp.com.br'
export const IMPERSONATION_STORAGE_KEY = 'devchat_impersonation_session_v1'
export const IMPERSONATION_REOPEN_KEY = 'devchat_impersonation_reopen_picker_v1'
export const IMPERSONATION_BAR_COLLAPSED_KEY = 'devchat_impersonation_bar_collapsed_v1'
export const IMPERSONATION_BAR_POSITION_KEY = 'devchat_impersonation_bar_position_v1'

export type ImpersonationCampaign = { id: string; name: string; companyId?: string }
export type ImpersonationUser = {
  id: string
  devzappUserId?: string
  authserverUserId?: string
  name: string
  email: string
  ownerId?: string
  companies: UserAuthenticated['companies']
  departments: UserAuthenticated['departments']
  attendCampaigns: UserAuthenticated['attendCampaigns']
  campaigns: ImpersonationCampaign[]
}
export type ImpersonationUsersPage = {
  users: ImpersonationUser[]
  pagination: { page: number; pageSize: number; total: number; hasNext: boolean }
}
export type ImpersonationSession = {
  firebaseSessionId: string
  oauthSessionId: string
  actorRestoreCustomToken: string
  expiresAt: number
  originalUser: UserAuthenticated
  simulatedUser: UserAuthenticated
  simulatedName: string
  simulatedEmail: string
  campaignId: string
  companyId: string
}
